import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
export class TreeviewStylingModel extends CoreStylingModel {

  item: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);

    if (this.item == null) { this.item = new StylingModel(); }
  }
}

function TreeviewStylingModel_tsickle_Closure_declarations() {
/** @type {?} */
TreeviewStylingModel.prototype.item;
}

